export default "__VITE_ASSET__6ee6ca3a__"